import { ws } from "../../../utils/common";

export const getInfoAssociationWS = async (id) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/info/" + id,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const getEventOfAssociationWS = async (id, limit) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event/association/" + id,
    { only_active: true, limit, calendar: true },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const getEventOfAssociationHistoryWS = async (id) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event/history/" + id,
    { popular: true },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const pushVisitWS = async (id_association) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "traffic-association/" + id_association,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const insertFavouriteAssociationWS = async (id_association) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "favourite-association/",
    null,
    { id_association },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const deleteFavouriteAssociationWS = async (id_association) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "favourite-association/" + id_association,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const becomeVolunteerOfAssociationWS = async (id_association) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "waiting-volunteer/",
    null,
    { id_association },
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};

export const exitFromAssociationWS = async (id_association) => {
  const res = await ws(
    "DELETE",
    process.env.REACT_APP_ENDPOINT + "user-association/" + id_association,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
